export const ADD_QUESTIONNAIRE = "ADD_QUESTIONNAIRE";
export const SET_QUESTION_IMAGE = "SET_QUESTION_IMAGE";
export const GET_QUESTION_IMAGE = "GET_QUESTION_IMAGE";
export const SET_OPTION_IMAGE = "SET_OPTION_IMAGE";
export const GET_OPTION_IMAGE = "GET_OPTION_IMAGE";
export const GET_THANKYOU_IMAGE = "GET_THANKYOU_IMAGE";
export const SET_THANKYOU_IMAGE = "SET_THANKYOU_IMAGE";
export const GET_SURVEY_BACKGROUND = "GET_SURVEY_BACKGROUND";
export const SET_SURVEY_BACKGROUND = "SET_SURVEY_BACKGROUND";
export const GET_QUESTIONNAIRES = "GET_QUESTIONNAIRES";
export const GET_QUESTIONNAIRE = "GET_QUESTIONNAIRE";
